import { atom } from "recoil";

export const inviteUUIDAtom = atom<string | null>({
  key: "inviteUUIDAtom",
  default: null,
});
